import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';

@Component({
  selector: 'app-square-view',
  templateUrl: './square-view.component.html',
  styleUrls: ['./square-view.component.scss'],
})
export class SquareViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isListViewSelected: any;
  @Input() items: any;
  @Output() emitCloseDialog = new EventEmitter<any>();
  selectedId: string | undefined;
  selectedZone: string | undefined;
  selected: string | undefined;
  subscription: Subscription | undefined;
  sharedData: any;

  constructor(public sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => (this.sharedData = sharedData)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.items?.currentValue?.length > 0 &&
      this.sharedData.selectedSite.siteName === ''
    ) {
      this.selected = this.items[0]?.siteName;
      this.sharedDataService.setSelectedSite({
        siteName: this.items[0]?.siteName,
        siteId: this.items[0]?.siteId,
        siteTimeZone: this.items[0]?.siteTimeZone,
        commonAccessControl: this.items[0]?.commonAccessControl,
      });
    }
  }

  onSelect(
    id: string,
    value: string,
    siteTimeZone: string,
    commonAccessControl: boolean
  ) {
    if (this.selected !== value) {
      this.selected = value;
      this.selectedId = id;
      this.selectedZone = siteTimeZone;
      this.sharedDataService.setSelectedSite({
        siteName: value,
        siteId: id,
        siteTimeZone: siteTimeZone,
        commonAccessControl: commonAccessControl,
      });
    }
    this.emitCloseDialog.emit(true);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
